import {
    ExpressPaymentMethods,
    InitialExperimentPostPaymentQuestionsVariant,
    PostCheckoutMandatoryQuestionsVariant,
    RecommendationsEnhancedExperimentVariant,
} from './types';

const ORDER_FORM_PAGE_EXPERIMENTS_LAYER = 'checkout_checkout_page_experiments';
const ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER =
    'checkout_order_confirmation_page_experiments';
const TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER =
    'checkout_ticket_selection_page_experiments';

export const URGENCY_SIGNALS_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'urgency_signals_visible',
};

export const SCROLLABLE_CTA_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: false,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'scrollable_cta',
};

export const GOOGLE_PAY_ON_TICKET_SELECTION_PAGE_EXPERIMENT = {
    defaultValue: ExpressPaymentMethods.paypal,
    layer: TICKET_SELECTION_PAGE_EXPERIMENTS_LAYER,
    param: 'enable_express_google_pay',
};

export const INITIAL_EXPERIMENT_POST_PAYMENT_QUESTIONS = {
    defaultValue: InitialExperimentPostPaymentQuestionsVariant.oldDesign,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'org_questions_page_design',
};

export const POST_CHECKOUT_MANDATORY_QUESTIONS = {
    defaultValue: PostCheckoutMandatoryQuestionsVariant.optionalQuestions,
    layer: ORDER_FORM_PAGE_EXPERIMENTS_LAYER,
    param: 'post_checkout_page_questions',
};

export const RECOMMENDATIONS_ENHANCED_EXPERIMENT = {
    defaultValue: RecommendationsEnhancedExperimentVariant.rightPaneFollowCard,
    layer: ORDER_CONFIRMATION_PAGE_EXPERIMENTS_LAYER,
    param: 'show_recommendations_enhanced',
};
